import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import mainReducer from "./reducers/main-reducer";
import { applyMiddleware, createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const middleware = [thunkMiddleware];

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, mainReducer);

let store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(...middleware)),
);
let persistor = persistStore(store);

export { store, persistor };
